// @flow
import _ from 'lodash';
import React, { useEffect } from 'react';
import { Spinner, TextStyle } from '@shopify/polaris';
import queryString from 'query-string';
import { routes } from 'src/routes';
import { app } from 'src/config/';

const regexShop = /^.+[.]myshopify.com$/;
const host = process.env.REACT_APP_ADMIN_V3_BASE_URL;
const connectUrl = `${host}/boost-pfs-admin/system/shopify/connect`;
const callbackUrl = `${host}/boost-pfs-admin/admin/google-analytics-4/oauth/callback`;

const CallbackGA4: React.FC = ({ location }) => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        let redirectPath = '';
        const queryParams = queryString.parse(location.search);
        const { code, state, error } = queryParams;
        const decodeQuery = decodeURIComponent(state);
        const tenantId = getTenantIdFromQuery(decodeQuery);

        if (!_.isEmpty(error)) {
          const redirectPathFailed = `https://${tenantId}/admin/apps/${app.apiKey}${routes.integration['google-analytics-4'].view()}?status=failed`;
          window.location = redirectPathFailed;
          return;
        }

        const rest = decodeQuery
          .split(',')
          .filter(text => !regexShop.test(text) || text.startsWith('shop'));
        const paramsConnect = rest.reduce((cur, next) => {
          const [field, value] = next.split('|');
          return {
            ...cur,
            [field]: value
          };
        }, {});

        // Authenticate with Boost backend to get auth token
        const response = await fetch(`${connectUrl}?${queryString.stringify(paramsConnect)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const dataShop = await response.json();

        if (dataShop.authToken) {
          const redirectUri = `${
            process.env.REACT_APP_FILTER_ADMIN_HTML_BASE_URL
          }${routes.integration['google-analytics-4'].callback()}`;
          const responseCallback = await fetch(callbackUrl, {
            method: 'POST',
            body: JSON.stringify({
              state: state,
              code,
              redirectURI: redirectUri
            }),
            headers: {
              'Content-Type': 'application/json',
              'x-bc-sf-filter-auth': dataShop.authToken
            }
          });

          const result = await responseCallback.json();

          if (result.statusCode === 200 && !_.isEmpty(result?.data)) {
            redirectPath = `https://${tenantId}/admin/apps/${app.apiKey}${routes.integration['google-analytics-4'].callbackSuccess()}`;
          } else {
            redirectPath = `https://${tenantId}/admin/apps/${app.apiKey}${routes.integration['google-analytics-4'].view()}?status=failed&errorCode=${encodeURIComponent(result?.errorCode || '')}`;
          }
          window.location = redirectPath
        }
      } catch (e) {
        console.error('GA4 OAuth callback error:', e);
      }
    };

    handleCallback();
  }, []);

  function getTenantIdFromQuery(query) {
    try {
      const base64Token = query.split(',')[0];
      const decodedText = atob(base64Token);
      const parsedState = JSON.parse(decodedText);
      return parsedState.tenantId || null;
    } catch (error) {
      console.error('Failed to parse tenantId from state query:', error);
      return null;
    }
  }

  return (
    <div className="callback-ga4">
      <Spinner />
      <p className="callback-ga4__title">Redirecting...</p>
      <p>
        <TextStyle variation="subdued">Please wait while redirect you.</TextStyle>
      </p>
    </div>
  );
};

export default CallbackGA4;
